/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  DRIVERS_MAP_LOADING,
  LOAD_CITIES,
  LOAD_DRIVERS_MAP,
  LOAD_SERVICES,
} from "../actions/mapActions";

const initialState = {
  cities: [],
  services: [],
  driversMap: [],
  mapLoading: false,
};

const mapReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CITIES: {
      const { levels } = action.payload;
      return produce(state, (draft) => {
        draft.cities = levels?.levels;
      });
    }

    case LOAD_SERVICES: {
      const { services } = action.payload;
      return produce(state, (draft) => {
        draft.services = services.data;
      });
    }

    case LOAD_DRIVERS_MAP: {
      const { drivers } = action.payload;
      return produce(state, (draft) => {
        draft.driversMap = drivers;
      });
    }
    case DRIVERS_MAP_LOADING: {
      const { loading } = action.payload;
      return produce(state, (draft) => {
        draft.mapLoading = loading;
      });
    }

    default: {
      return state;
    }
  }
};

export default mapReducer;
